export default __webpack_public_path__ + "1b7ac67f5da722982e5eb036b5401ec5.png";